const Area = () =>
  import(/* webpackChunkName: "blog-area" */ '@/pages/blog/blog/area/index.vue')

const CreateArea = () =>
  import(
    /* webpackChunkName: "blog-area" */ '@/pages/blog/blog/area/create.vue'
  )

const EditArea = () =>
  import(
    /* webpackChunkName: "blog-area" */ '@/pages/blog/blog/area/edit.vue'
  )

export default {
  path: 'area',
  meta: {
    label: 'area',
    auth: 'area'
  },
  component: {
    name: 'Area',
    render(c) {
      return c('router-view')
    }
  },
  children: [
    {
      name: 'BlogAreaReport',
      path: '',
      meta: {
        label: 'report',
        auth: 'report'
      },
      component: Area
    },
    {
      name: 'BlogCreateArea',
      path: 'create',
      meta: {
        label: 'create',
        auth: 'create'
      },
      component: CreateArea
    },
    {
      name: 'BlogEditArea',
      path: 'area/edit/:id',
      meta: {
        label: 'edit',
        auth: 'update'
      },
      component: EditArea,
      props: true
    }
  ]
}
